<template>
  <div class="seek_add_page">
    <div
      class="top-container flex_center"
      style="cursor: pointer"
      @click="back"
    >
      <i class="el-icon-arrow-left" />
      <div class="split"></div>
      {{ $t("home.createConsultation") }}
    </div>
    <div class="form_info">
      <el-form :inline="true" :model="seekInfo" ref="seekInfo">
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("seek.workBasic") }}
          </div>
        </div>
        <div class="form-container">
          <el-form-item :label="$t('seek.theme')" required>
            <el-input v-model="seekInfo.consultSubject"></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.happenDate')" required>
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              placeholder=""
              v-model="seekInfo.happenDate"
              style="width: 250px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('seek.warrantyDate')" required>
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              placeholder=""
              v-model="seekInfo.repairsDate"
              style="width: 250px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('seek.quantity')">
            <el-input
              @input="inputCarCount"
              type="text"
              v-model="seekInfo.carCount"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.HappenPlace')" required>
            <el-input v-model="seekInfo.happenPlace"></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.attribute')" required>
            <el-radio-group
              v-model="seekInfo.carAttributes"
              class="radio-group"
            >
              <el-radio :label="1">{{ $t("seek.commercial") }} </el-radio>
              <el-radio :label="2">{{ $t("seek.domestic") }} </el-radio>
              <el-radio :label="3">{{ $t("seek.nonDomestic") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('seek.distance')" required>
            <el-input
              @input="inputMileage"
              type="number"
              v-model="seekInfo.roadHaul"
            >
              <template slot="append">km</template>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.culpritName')" required>
            <el-input v-model="seekInfo.suspectedCulpritName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.culpritCode')">
            <el-input v-model="seekInfo.suspectedCulpritCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.supplier')">
            <el-input
              v-model="seekInfo.suspectedCulpritSupplierCode"
            ></el-input>
          </el-form-item>
        </div>
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("seek.basic") }}
          </div>
        </div>
        <!-- <el-divider content-position="left">{{ $t("seek.basic") }}</el-divider> -->
        <div class="form-container">
          <el-form-item label="VIN:" required>
            <!--  -->
            <el-input @input="inputVin" v-model="vin"></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.color')" required>
            <el-input v-model="seekInfo.carColor"></el-input>
          </el-form-item>
          <el-form-item :label="$t('home.brand')" required>
            <el-input v-model="seekInfo.carBrand"></el-input>
          </el-form-item>
          <el-form-item :label="$t('home.carType')" required>
            <el-input v-model="seekInfo.carModel"></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.produceDate')" required>
            <!-- <el-input v-model=" seekInfo.productionDate"></el-input> -->
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              placeholder=""
              v-model="seekInfo.productionDate"
              style="width: 250px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('seek.buyDate')" required>
            <!-- <el-input v-model=" seekInfo.salesDate"></el-input> -->
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              placeholder=""
              v-model="seekInfo.salesDate"
              style="width: 250px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('seek.onlyEngine')" required>
            <el-input v-model="seekInfo.engineModel"></el-input>
          </el-form-item>
          <el-form-item :label="$t('seek.engineNUmber')" required>
            <el-input v-model="seekInfo.engineNumber"></el-input>
          </el-form-item>
        </div>
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("seek.maintenanceInfo") }}
            <el-tooltip
              effect="light"
              :content="$t('request.content')"
              placement="right"
            >
              <div slot="content">
                <div class="titleTip">
                  <span>
                    {{ $t("request.content") }}
                  </span>
                </div>
                <div class="titleTip">
                  <div>
                    <span>{{ $t("request.tips") }}</span>
                  </div>
                  <p>⑴{{ $t("request.first") }}</p>
                  <p>⑵{{ $t("request.lx") }}</p>
                </div>
              </div>
              <i
                class="el-icon-question"
                style="color: #bd3124; margin-left: 5px"
              />
            </el-tooltip>
          </div>
        </div>
        <div class="form-container">
          <div v-for="(item, index) in seekInfo.intervalList" :key="index">
            <el-form-item :label="$t(`seek.insuranceDate${index + 1}`)">
              <el-date-picker
                value-format="yyyy-MM-dd"
                type="date"
                placeholder=""
                v-model="seekInfo.intervalList[index].insuranceDate"
                style="width: 250px"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t(`seek.insuranceMileage${index + 1}`)">
              <el-input
                @input="inputMileageFirst"
                type="number"
                v-model="seekInfo.intervalList[index].insuranceMileage"
              >
                <template slot="append">km</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t(`seek.insuranceProject${index + 1}`)">
              <el-input
                v-model="seekInfo.intervalList[index].insuranceProject"
              ></el-input>
            </el-form-item>
            <el-button
              v-if="
                seekInfo.intervalList.length > 5 &&
                index === seekInfo.intervalList.length - 1
              "
              style="color: #bd3124"
              type="text"
              @click="handleDeleteCycle"
            >
              {{ $t("seek.delete") }}
            </el-button>
          </div>
          <div class="add-maintenance-cycle">
            <el-button
              v-if="seekInfo.intervalList.length < 20"
              style="color: #bd3124"
              type="text"
              @click="handleAddCycle"
            >
              <i class="el-icon-circle-plus-outline" /> {{ $t("seek.addMaintenanceCycle") }}
            </el-button>
          </div>
        </div>
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("seek.hitchDeac") }}
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('seek.hitchDeacTip')"
              placement="right"
            >
              <i
                class="el-icon-question"
                style="color: #bd3124; margin-left: 5px"
              />
            </el-tooltip>
          </div>
        </div>
        <!-- <el-divider content-position="left">
        {{ $t("seek.hitchDeac") }}
      </el-divider> -->
        <div class="hitch_info">
          <div class="form-container">
            <el-form-item :label="$t('seek.drivingConditions')" required>
              <el-checkbox
                :label="$t('seek.moderate')"
                v-model="seekInfo.speedDown"
                name="type"
              ></el-checkbox>
              <el-checkbox
                :label="$t('seek.retardation')"
                v-model="seekInfo.braking"
                name="type"
              ></el-checkbox>
              <el-checkbox
                :label="$t('seek.turn')"
                v-model="seekInfo.steer"
                name="type"
              ></el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('seek.position')">
              <el-input type="text" v-model="seekInfo.gearValue"> </el-input>
            </el-form-item>
            <el-form-item :label="$t('seek.speed')">
              <el-input
                @input="inputKm"
                type="number"
                v-model="seekInfo.drivingSpeedValue"
              >
                <template slot="append">km/h</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('seek.engineSpeed')">
              <el-input
                @input="inputR"
                type="number"
                v-model="seekInfo.engineSpeedValue"
              >
                <template slot="append">r/min</template>
              </el-input>
            </el-form-item>
          </div>
          <div class="form-container">
            <el-form-item :label="$t('seek.roadType')" required>
              <el-checkbox
                v-model="seekInfo.concreteRoad"
                :label="$t('seek.cement')"
                name="type"
              ></el-checkbox>
              <el-checkbox
                v-model="seekInfo.asphaltRoad"
                :label="$t('seek.asphalt')"
                name="type"
              ></el-checkbox>
              <el-checkbox
                v-model="seekInfo.dirtRoad"
                :label="$t('seek.unpaved')"
                name="type"
              ></el-checkbox>
              <el-checkbox
                v-model="seekInfo.gravelRoad"
                :label="$t('seek.gravel')"
                name="type"
              ></el-checkbox>
              <el-checkbox
                v-model="seekInfo.coalSlagRoad"
                :label="$t('seek.cinder')"
                name="type"
              ></el-checkbox>
            </el-form-item>
          </div>
          <div class="form-container">
            <el-form-item :label="$t('seek.roadCondition')" required>
              <el-checkbox
                v-model="seekInfo.uneven"
                :label="$t('seek.unsmooth')"
                name="type"
              ></el-checkbox>
              <el-checkbox
                v-model="seekInfo.flat"
                :label="$t('seek.even')"
                name="type"
              ></el-checkbox>
              <el-checkbox
                v-model="seekInfo.uphill"
                :label="$t('seek.upslope')"
                name="type"
              ></el-checkbox>
              <el-checkbox
                v-model="seekInfo.downhill"
                :label="$t('seek.downhill')"
                name="type"
              ></el-checkbox>
            </el-form-item>
          </div>
          <div class="form-container">
            <el-form-item :label="$t('seek.road')" required>
              <el-checkbox
                v-model="seekInfo.standingWater"
                :label="$t('seek.ponding')"
                name="type"
              ></el-checkbox>
              <el-checkbox
                v-model="seekInfo.freeze"
                :label="$t('seek.freeze')"
                name="type"
              ></el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-form-item>
                <el-checkbox
                  v-model="seekInfo.roadConditionsOther"
                  :label="$t('seek.other')"
                  name="type"
                  @change="
                    () => {
                      seekInfo.roadConditionsOtherValue = '';
                    }
                  "
                ></el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-input
                  :disabled="!seekInfo.roadConditionsOther"
                  type="text"
                  v-model="seekInfo.roadConditionsOtherValue"
                ></el-input>
              </el-form-item>
            </el-form-item>
          </div>
          <div class="form-container">
            <el-form-item :label="$t('seek.weather')" required>
              <el-checkbox
                v-model="seekInfo.clearDay"
                :label="$t('seek.sun')"
                name="type"
              ></el-checkbox>
              <el-checkbox
                v-model="seekInfo.rain"
                :label="$t('seek.rain')"
                name="type"
              ></el-checkbox>
              <el-checkbox
                v-model="seekInfo.heavySnow"
                :label="$t('seek.snow')"
                name="type"
              ></el-checkbox>
              <el-checkbox
                v-model="seekInfo.strongWind"
                :label="$t('seek.wind')"
                name="type"
              ></el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-form-item>
                <el-checkbox
                  v-model="seekInfo.weatherConditionsOther"
                  :label="$t('seek.other')"
                  name="type"
                  @change="
                    () => {
                      seekInfo.weatherConditionsOtherValue = '';
                    }
                  "
                ></el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-input
                  :disabled="!seekInfo.weatherConditionsOther"
                  type="text"
                  v-model="seekInfo.weatherConditionsOtherValue"
                ></el-input>
              </el-form-item>
            </el-form-item>
          </div>

          <div class="form-container">
            <el-form-item :label="$t('seek.PassengerCapacity')" required>
              <el-input type="number" v-model="seekInfo.passengerCapacity">
                <template slot="append">人</template>
              </el-input>
            </el-form-item>
          </div>
          <div class="form-container">
            <el-form-item :label="$t('seek.PassengerWeight')" required>
              <el-input type="number" v-model="seekInfo.cargoWeight">
                <template slot="append">kg</template>
              </el-input>
            </el-form-item>
          </div>

          <div class="form-container">
            <el-form-item :label="$t('seek.moreDesc')">
              <el-input
                style="width: 680px"
                type="textarea"
                v-model="seekInfo.moreDescription"
                :placeholder="$t('seek.describePlaceholder')"
                maxlength="1000"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-container">
            <el-form-item :label="$t('seek.appendix')" required>
              <el-upload
                class="upload-demo"
                ref="uploadFile"
                drag
                :headers="header"
                :action="action"
                :on-success="handleFileSuccess"
                :before-upload="beforeFileUpload"
                :on-remove="handleRemoveFile"
                :on-change="handleChange"
                multiple
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{ $t("seek.dragFile") }}</div>
                <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
            </el-form-item>
            <el-form-item>
              <div class="tips">
                <p>{{ $t("seek.formats") }}：</p>
                <p>1.{{ $t("seek.img") }}：jpg、png、jpeg、svg</p>
                <span>{{ $t("seek.limit10") }}</span>
                <p>2.{{ $t("seek.video") }}：mp4 、3gp、mov、m4v</p>
                <span>{{ $t("seek.limit100") }}</span>
                <p>3.{{ $t("seek.table") }}：xlsx</p>
                <span>{{ $t("seek.limit20") }}</span>
                <p>4.{{ $t("seek.doc") }}：doc、docx、pdf</p>
                <span>{{ $t("seek.limitDoc20") }}</span>
                <p>{{ $t("seek.appendixTotal") }}</p>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="flex_default_center">
      <el-button
        class="primary-btn"
        :disabled="uploading"
        @click="handleAddNewSeek"
        size="small"
        type="primary"
        >{{ $t("seek.submit") }}</el-button
      >
      <el-button
        class="primary-btn"
        @click="resetInfo"
        size="small"
        type="primary"
        >{{ $t("home.reset") }}</el-button
      >
    </div>
  </div>
</template>

<script>
import { newSeek, getVinData, deleteFile } from "@/api/seek";
import { debounce } from "@/util/debounce";
import { totalSum } from "@/util/totalSum";
import { uploadUrl } from "@/util/url";
export default {
  components: {},
  data() {
    return {
      upLoadFiles: [],
      vinVal: "",
      // vin:'',
      uploading: false,
      header: {
        satoken: sessionStorage.getItem("satoken"),
      },
      fileList: [],
      // action:'/api/customer/quality/upload', //开发
      action: uploadUrl + "/customer/quality/upload",
      //  action:'http://43.157.63.49:8187/customer/quality/upload',
      seekInfo: {
        consultSubject: "",
        happenDate: "",
        repairsDate: "",
        carCount: "",
        happenPlace: "",
        carAttributes: "",
        roadHaul: "",
        suspectedCulpritName: "",
        suspectedCulpritCode: "",
        suspectedCulpritSupplierCode: "",
        vin: "",
        carColor: "",
        carBrand: "",
        carModel: "",
        productionDate: "",
        salesDate: "",
        engineModel: "",
        engineNumber: "",
        oneInsuranceDate: "",
        oneInsuranceMileage: "",
        oneInsuranceProject: "",
        twoInsuranceDate: "",
        twoInsuranceMileage: "",
        twoInsuranceProject: "",
        threeInsuranceDate: "",
        threeInsuranceMileage: "",
        threeInsuranceProject: "",
        fourInsuranceDate: "",
        fourInsuranceMileage: "",
        fourInsuranceProject: "",
        fiveInsuranceDate: "",
        fiveInsuranceMileage: "",
        fiveInsuranceProject: "",
        speedDown: "",
        braking: "",
        steer: "",
        gear: "",
        gearValue: "",
        drivingSpeed: "",
        drivingSpeedValue: "",
        engineSpeed: "",
        engineSpeedValue: "",
        flat: "",
        standingWater: "",
        freeze: "",
        uneven: "",
        uphill: "",
        downhill: "",
        concreteRoad: "",
        asphaltRoad: "",
        dirtRoad: "",
        gravelRoad: "",
        coalSlagRoad: "",
        bumpiness: "",
        roadConditionsOther: "",
        roadConditionsOtherValue: "",
        clearDay: "",
        rain: "",
        heavySnow: "",
        strongWind: "",
        weatherConditionsOther: "",
        weatherConditionsOtherValue: "",
        food: "",
        textile: "",
        furniture: "",
        productTypesOther: "",
        productTypesOtherValue: "",
        overloadOrNot: "",
        moreDescription: "",
        intervalList: [
          {
            insuranceDate: "",
            insuranceMileage: "",
            insuranceProject: "",
            insuranceType: "1",
          },
          {
            insuranceDate: "",
            insuranceMileage: "",
            insuranceProject: "",
            insuranceType: "2",
          },
          {
            insuranceDate: "",
            insuranceMileage: "",
            insuranceProject: "",
            insuranceType: "3",
          },
          {
            insuranceDate: "",
            insuranceMileage: "",
            insuranceProject: "",
            insuranceType: "4",
          },
          {
            insuranceDate: "",
            insuranceMileage: "",
            insuranceProject: "",
            insuranceType: "5",
          },
        ],
        passengerCapacity: "",
        cargoWeight: "",
      },
      max: 500,
      sum: 0,
    };
  },
  created() {
    this.$watch(
      "seekInfo.vin",
      debounce((newQuery) => {
        // newQuery为输入的值
        this.getCarInfo();
      }, 300)
    );
  },
  computed: {
    vin: {
      get: function () {
        return this.vinVal;
      },
      set: function (val) {
        this.vinVal = val.toUpperCase();
        this.seekInfo.vin = this.vinVal;
      },
    },
  },

  methods: {
    back() {
      this.$router.go(-1);
    },
    handleChange(file, fileList) {
      this.upLoadFiles = fileList;
    },
    handleRemoveFile(file, fileList) {
      this.uploading = false;
      let uid = file.response.data.uploadFileId;
      this.deleteUploadFile(file);
      this.fileList.forEach((pic, i) => {
        if (pic.uploadFileId == uid) {
          this.fileList.splice(i, 1);
        }
      });

      // console.log('remove',this.uploading)
      // console.log(this.fileList)
    },
    async deleteUploadFile(data) {
      let query = {
        data: {
          uploadFileId: data.response.data.uploadFileId,
          filePath: data.response.data.filePath,
        },
      };
      const res = await deleteFile(query);
      // console.log(res)
    },
    inputMileage(val) {
      if (val.indexOf(".") != -1) {
        let sub = val.substring(0, val.indexOf(".") + 3);
        this.seekInfo.roadHaul = sub;
      }
    },
    inputMileageFirst(val) {
      if (val.indexOf(".") != -1) {
        let sub = val.substring(0, val.indexOf(".") + 3);
        this.seekInfo.oneInsuranceMileage = sub;
      }
    },
    inputMileageSecond(val) {
      if (val.indexOf(".") != -1) {
        let sub = val.substring(0, val.indexOf(".") + 3);
        this.seekInfo.twoInsuranceMileage = sub;
      }
    },
    inputMileageThird(val) {
      if (val.indexOf(".") != -1) {
        let sub = val.substring(0, val.indexOf(".") + 3);
        this.seekInfo.threeInsuranceMileage = sub;
      }
    },
    inputMileageFour(val) {
      if (val.indexOf(".") != -1) {
        let sub = val.substring(0, val.indexOf(".") + 3);
        this.seekInfo.fourInsuranceMileage = sub;
      }
    },
    inputMileageFive(val) {
      if (val.indexOf(".") != -1) {
        let sub = val.substring(0, val.indexOf(".") + 3);
        this.seekInfo.fiveInsuranceMileage = sub;
      }
    },
    inputR(val) {
      if (val.indexOf(".") != -1) {
        let sub = val.substring(0, val.indexOf(".") + 3);
        this.seekInfo.engineSpeedValue = sub;
      }
    },
    inputKm(val) {
      if (val.indexOf(".") != -1) {
        let sub = val.substring(0, val.indexOf(".") + 3);
        this.seekInfo.drivingSpeedValue = sub;
      }
    },
    inputCarCount(value) {
      let a = value.match(/^\+?[1-9]\d*$/);
      if (a != null) {
        this.seekInfo.carCount = Number(a[0]);
      } else {
        this.seekInfo.carCount = "";
      }

      // this.seekInfo.carCount = value.replace(/^\+?[1-9]\d*$/, '')
    },
    beforeFileUpload(file) {
      this.uploading = true;
      let lang = "";
      let language = sessionStorage.getItem("lang");
      language == "zh"
        ? (lang = 0)
        : language == "en"
        ? (lang = 1)
        : language == "ru"
        ? (lang = 2)
        : (lang = 3);
      this.header.lang = lang;
      let total = 0;
      total = this.sum + file.size / 1024 / 1024;
      // console.log(total)
      if (total >= this.max) {
        this.$DonMessage.warning(this.$t("home.fileSum"));
        this.uploading = false;
        return false;
      }
      const imgLt = 10;
      const videoLt = 100;
      const xlsLt = 20;
      const docLt = 20;
      let limit = 0;
      let isLt = 0;
      // 图片
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSvg = file.type === "image/svg+xml";
      let isImg = false;
      if (isJPG || isPNG || isSvg) {
        isImg = true;
      }
      if (isImg) {
        limit = imgLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning(this.$t("home.img10M"));
          this.uploading = false;
        }
        return isImg && isLt;
      }

      // 视频
      const isMP4 = file.type === "video/mp4";
      const is3GP = file.type === "video/3gpp";
      const isMOV = file.type === "video/quicktime";
      const isM4V = file.type === "";
      let isVideo = false;
      if (isMP4 || is3GP || isMOV) {
        isVideo = true;
      }
      if (isVideo) {
        limit = videoLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning(this.$t("home.video100M"));
          this.uploading = false;
        }
        return isVideo && isLt;
      }

      // 表格
      const isXLS =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (isXLS) {
        limit = xlsLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning(this.$t("xlsx20M"));
          this.uploading = false;
        }
        return isXLS && isLt;
      }

      // 文档
      const isDOC = file.type === "application/msword";
      const isDOCX =
        file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const isPDF = file.type === "application/pdf";
      let isFile = false;
      if (isDOC || isDOCX || isPDF) {
        isFile = true;
      }
      if (isFile) {
        limit = docLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning(this.$t("doc20M"));
          this.uploading = false;
        }
        return isFile && isLt;
      }
    },
    resetInfo() {
      this.$confirm(this.$t("seek.resetContent"), this.$t("seek.isReset"), {
        confirmButtonText: this.$t("seek.confirm"),
        cancelButtonText: this.$t("home.thinkAgain"),
        type: "warning",
      }).then(() => {
        this.handleReset();
      });
    },
    handleReset() {
      this.seekInfo = {
        consultSubject: "",
        happenDate: "",
        repairsDate: "",
        carCount: "",
        happenPlace: "",
        carAttributes: "",
        roadHaul: "",
        suspectedCulpritName: "",
        suspectedCulpritCode: "",
        suspectedCulpritSupplierCode: "",
        vin: "",
        carColor: "",
        carBrand: "",
        carModel: "",
        productionDate: "",
        salesDate: "",
        engineModel: "",
        engineNumber: "",
        oneInsuranceDate: "",
        oneInsuranceMileage: "",
        oneInsuranceProject: "",
        twoInsuranceDate: "",
        twoInsuranceMileage: "",
        twoInsuranceProject: "",
        threeInsuranceDate: "",
        threeInsuranceMileage: "",
        threeInsuranceProject: "",
        fourInsuranceDate: "",
        fourInsuranceMileage: "",
        fourInsuranceProject: "",
        fiveInsuranceDate: "",
        fiveInsuranceMileage: "",
        fiveInsuranceProject: "",
        speedDown: "",
        braking: "",
        steer: "",
        gear: "",
        gearValue: "",
        drivingSpeed: "",
        drivingSpeedValue: "",
        engineSpeed: "",
        engineSpeedValue: "",
        flat: "",
        standingWater: "",
        freeze: "",
        uneven: "",
        uphill: "",
        downhill: "",
        concreteRoad: "",
        asphaltRoad: "",
        dirtRoad: "",
        gravelRoad: "",
        coalSlagRoad: "",
        bumpiness: "",
        roadConditionsOther: "",
        roadConditionsOtherValue: "",
        clearDay: "",
        rain: "",
        heavySnow: "",
        strongWind: "",
        weatherConditionsOther: "",
        weatherConditionsOtherValue: "",
        food: "",
        textile: "",
        furniture: "",
        productTypesOther: "",
        productTypesOtherValue: "",
        overloadOrNot: "",
        moreDescription: "",
        intervalList: [
          {
            insuranceDate: "",
            insuranceMileage: "",
            insuranceProject: "",
            insuranceType: "1",
          },
          {
            insuranceDate: "",
            insuranceMileage: "",
            insuranceProject: "",
            insuranceType: "2",
          },
          {
            insuranceDate: "",
            insuranceMileage: "",
            insuranceProject: "",
            insuranceType: "3",
          },
          {
            insuranceDate: "",
            insuranceMileage: "",
            insuranceProject: "",
            insuranceType: "4",
          },
          {
            insuranceDate: "",
            insuranceMileage: "",
            insuranceProject: "",
            insuranceType: "5",
          },
        ],
        passengerCapacity: "",
        cargoWeight: "",
      };
      this.fileList = [];
    },

    // 上传附件
    handleFileSuccess(res, file) {
      // console.log(res)
      if (res.status == 0) {
        let data = res.data;
        let obj = {
          uploadFileId: data.uploadFileId,
          // dataId: data.dataId,
          uploaderId: data.uploaderId,
          fileName: data.fileName,
          fileSize: data.fileSize,
          fileType: data.fileType,
          filePath: encodeURI(data.filePath),
          fileSource: data.fileSource,
        };
        this.fileList.push(obj);
        const total = totalSum(this.fileList, "fileSize");
        this.sum = total / 1024;
        if (this.upLoadFiles.length == this.fileList.length) {
          this.uploading = false;
        }
        //  this.uploading = false
      } else {
        if (this.upLoadFiles.length == this.fileList.length) {
          this.uploading = false;
        }
        this.$DonMessage.warning(res.message);
        let uid = file.uid; // 关键作用代码，去除文件列表失败文件
        let idx = this.$refs.uploadFile.uploadFiles.findIndex(
          (item) => item.uid === uid
        );
        this.$refs.uploadFile.uploadFiles.splice(idx, 1);
      }
    },
    // 处理数据 把true变成1 false变成0
    workData(obj) {
      for (var key in obj) {
        if (obj[key] == true) {
          obj[key] = 1;
        }
        if (obj[key] == false) {
          obj[key] = "";
        }
      }
      // console.log(obj,'resssssssssset')
      return obj;
    },
    // 校验并提交
    handleSubmit() {
      this.$confirm("", this.$t("home.isSubmitQustion"), {
        confirmButtonText: this.$t("seek.confirm"),
        cancelButtonText: this.$t("seek.cancel"),
        type: "warning",
      }).then(() => {
        if (this.fileList.length == 0) {
          this.$DonMessage.warning(this.$t("home.fileMust"));
          return;
        }
        this.seekInfo.vin = this.vin;
        this.handleAddNewSeek();
      });
    },
    // 新增咨询单
    async handleAddNewSeek() {
      // this.seekInfo.fileList = this.fileList
      let obj = JSON.parse(JSON.stringify(this.seekInfo));
      this.workData(obj);
      obj.fileList = this.fileList;
      let query = {
        data: {
          ...obj,
        },
      };
      // console.log(query.data)
      // return
      const res = await newSeek(query);
      // console.log(res)
      if (res.status == 0) {
        this.$DonMessage.success(this.$t("home.seekAddOk"));
        this.$router.push("/seek");
      } else {
        this.$DonMessage.warning(res.message);
      }
    },
    inputVin(value) {
      // this.search()
      // this.bb
      this.getCarInfo();
    },

    // 根据输入的vin查询相关数据
    async getCarInfo() {
      let query = {
        data: {
          vin: this.vin,
          // vin:vin
        },
      };
      const res = await getVinData(query);
      // console.log(res,'--------------carData--------------')
      if (res.status == 0) {
        if (res.data) {
          // 为真填充
          let obj = res.data;
          this.seekInfo.carColor = obj.carColor;
          this.seekInfo.carBrand = obj.carBrand;
          this.seekInfo.carModel = obj.carModel;
          this.seekInfo.productionDate = obj.productionDate;
          this.seekInfo.salesDate = obj.salesDate;
          this.seekInfo.engineModel = obj.engineModel;
          this.seekInfo.engineNumber = obj.engineNumber;
        }
      }
    },

    // 添加保养周期
    handleAddCycle() {
      this.seekInfo.intervalList.push({
        insuranceDate: "",
        insuranceMileage: "",
        insuranceProject: "",
        insuranceType: this.seekInfo.intervalList.length + 1,
      });
    },

    // 删除保养周期
    handleDeleteCycle() {
      this.seekInfo.intervalList.splice(-1, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.seek_add_page {
  padding: 0 !important;
  margin-top: 15px;
  // padding-bottom: 20px;
  .top-container {
    padding: 0 32px 15px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    margin-bottom: 34px;
    .title-icon {
      margin-right: 10px;
    }
    .flex_between{
      display: flex !important;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .tips {
    line-height: 20px;
    color: #cecece;
    font-size: 14px;
    // p {
    //   font-size: 14px;
    //   line-height: 20px;
    // }
    // span {
    //   font-size: 12px;
    //   line-height: 16px;
    // }
  }
  .car_tips {
    border: 1px solid rgb(187, 187, 187);
    background: rgba(147, 210, 243, 0.53);
    box-sizing: border-box;
    display: flex;
    padding: 16px;
    margin: 10px 20px 0 20px;
    border-radius: 6px;
    .left {
      width: 15%;
      margin-right: 10px;
      border-right: 1px solid rgb(187, 187, 187);
      div {
        height: 30px;
        display: flex;
        align-items: center;
        i {
          color: #e6a23c;
          font-size: 20px;
          // line-height: 30px;
        }
        span {
          // display: inline-block;
          margin-left: 5px;
          font-size: 14px;
          // line-height: 30px;
          font-weight: bold;
          color: #333;
        }
      }
      p {
        font-size: 14px;
        color: rgba(154, 154, 154);
        font-style: normal;
        letter-spacing: 0px;
        line-height: 21px;
      }
    }
    .right {
      width: 80%;
      span {
        font-size: 14px;
        color: rgb(154, 154, 154);
        font-style: normal;
        letter-spacing: 0px;
        line-height: 21px;
      }
    }
  }

  ::v-deep .el-input {
    // width: 250px;
  }
  .form-container {
    padding: 0 60px;
    ::v-deep {
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #bd3124;
        border-color: #bd3124;
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: unset;
      }
      .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #bd3124;
      }
    }
  }
  .add-maintenance-cycle {
    text-align: center;
  }
}
.titleTip {
  width: 800px;
  line-height: 28px;
}
</style>
